import { Map } from "@vis.gl/react-google-maps";
import { StyledGoogleMaps } from "../../../styled/googleMaps";

const GoogleMapCanvas = ({ center, zoom, children }) => (
  <StyledGoogleMaps.MapContainer
    sx={{ height: "100%", minHeight: 0, margin: 0 }}>
    <Map
      defaultCenter={center}
      defaultZoom={zoom}
      disableDefaultUI
      gestureHandling="greedy"
      mapId="DEMO_MAP_ID"
      reuseMaps>
      {children}
    </Map>
  </StyledGoogleMaps.MapContainer>
);

export default GoogleMapCanvas;
